<template>
	<div class="feedback">
		<div class="feedback_title">欢迎留下您的宝贵意见</div>
		<div class="feedback_input">
			<van-field
				v-model="content"
				name="意见"
				type="textarea"
				autosize
				placeholder="意见内容"
			/>
			<van-field
				v-model="mobile"
				name="手机号码"
				type="tel"
				placeholder="请输入手机号码"
			/>
		</div>
		
	  	<div class="mvbutton" @click="onSubmit">提交</div>
	</div>
</template>
<script>
    import "./index.less"
    import {Form, Field} from 'vant'
    export default {
        name: 'index',
        components:{
            vanForm:Form,
            vanField:Field
        },
        data() {
		    return {
		      content: '',
		      mobile: '',
		    };
	  	},
	  	methods: {
		    onSubmit(values) {
		      	if(this.content==''){
                    this.$toast.fail('请填写您的意见！');
                    return;
                }
                let con = this.content.trim()
                if(con.length<10){
                	this.$toast.fail('您填写的内容不能小于10个字！');
                    return;
                }
                this.$api.user.h5feedback({mobile: this.mobile,content: this.content}).then((res) => {
                    if (res.status * 1 === 200) {
                        this.$toast.success('提交成功！');
                        this.$router.replace({name:'exchange',params:{id:3}})
                    }
                });
		    },
	  	},
        mounted() {
            this.$nextTick(() => {
                // this.initIndex();
            })

        }
    }
</script>